import {Component, input} from '@angular/core';
import {FormControl, ReactiveFormsModule} from '@angular/forms';
import {Checkbox} from 'primeng/checkbox';


@Component({
  selector: 'elcia-check-box',
  imports: [
    Checkbox,
    ReactiveFormsModule
  ],
  templateUrl: './check-box.html',
  styleUrl: './check-box.scss',
})

export class CheckBox {
  control = input<FormControl<boolean | null>>();
  label = input<string>();
  labelSide = input<Side>('right');
}

type Side = 'left' | 'right';
